import Rewards_View from "../../views/rewards/rewards";

export default class Rewards extends Rewards_View {
  handleChange = (e, newValue) => {
    this.setState({ currentTab: newValue });
  };
}
